import React from 'react';

export const ManualBulkCreateLoadingImage = () => (
	<svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M79.85 47.0573H31.14V70.8573H79.85V47.0573Z" fill="#BF63F3" />
		<path d="M64.71 32.2773H16V56.0773H64.71V32.2773Z" fill="#FCA700" />
		<path d="M64.71 47.0573H31.14V56.0773H64.71V47.0573Z" fill="#AE2A19" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M76.82 55.6573L66.33 66.1473L60.91 60.5773L63.25 58.3073L66.37 61.5073L74.52 53.3573L76.83 55.6673L76.82 55.6573Z"
			fill="white"
		/>
	</svg>
);
